import React from 'react'

const SmartLinksIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M14.1625 18.4876L13.4417 19.2084C11.053 21.5971 7.18019 21.5971 4.79151 19.2084C2.40283 16.8198 2.40283 12.9469 4.79151 10.5583L5.51236 9.8374" stroke="#171717" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M9.83594 14.1625L14.161 9.8374" stroke="#171717" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M9.83594 5.51236L10.5568 4.79151C12.9455 2.40283 16.8183 2.40283 19.207 4.79151C21.5957 7.18019 21.5957 11.053 19.207 13.4417L18.4861 14.1625" stroke="#171717" stroke-width="1.5" stroke-linecap="round"/>
</svg>
  )
}

export default SmartLinksIcon